module.exports = __webpack_public_path__ + "static/media/be.8e6fc60f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/be.svg
// module id = 866
// module chunks = 0